module.exports = __webpack_public_path__ + "img/DSC_1886.904f5de7.JPG";